/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T16:00:11+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import EventListener from 'react-event-listener';
import keycode from 'keycode';
import transitions from './../../../transitions/transitions';
import MActionsCalendar from './MActionsCalendar';
import MMonthCalendar from './MMonthCalendar';
import MYearCalendar from './MYearCalendar';
import MToolbarCalendar from './MToolbarCalendar';
import MDisplayDate from './MDisplayDate';
import SlideInTransitionGroup from './../../../transitions/SlideIn';
import {LANDSCAPE, PORTRAIT} from './../constants/mode';


import {
  addDays,
  addMonths,
  addYears,
  cloneDate,
  isAfterDate,
  isBeforeDate,
  getWeekArray,
  getFirstDayOfMonth,
  localizedWeekday,
  monthDiff,
} from './dateUtils';

const daysArray = [...Array(7)];

/**
 * OCalendarDatePicker - …
 */
class OCalendarDatePicker extends Component {
    state = {
      displayDate: undefined,
      displayMonthDay: true,
      selectedDate: undefined,
      transitionDirection: 'left',
      transitionEnter: true,
    };

    /**
     * react lifecycle componentWillUnmount() <OCalendarDatePicker>
     *
     * @return {undefined}
     */
    componentWillMount() {
      this.setState({
        displayDate: getFirstDayOfMonth(this.props.initialDate),
        selectedDate: this.props.initialDate,
        displayMonthDay: !this.props.startWithYears,
      });

      this._calendarComp = null; // we manually remove a ref here
    }

    /**
     * react lifecycle componentWillReceiveProps() <OCalendarDatePicker>
     *
     * @param {object} nextProps
     * @return {undefined}
     */
    componentWillReceiveProps(nextProps) {
      if (nextProps.initialDate !== this.props.initialDate) {
        const date = nextProps.initialDate || new Date();
        this.setState({
          displayDate: getFirstDayOfMonth(date),
          selectedDate: date,
        });
      }
    }

    /**
     * react render() <OCalendarDatePicker>
     *
     * @return {object}
     */
    render() {
      const weekCount = getWeekArray(this.state.displayDate, this.props.firstDayOfWeek).length;
      const toolbarInteractions = this.getToolbarInteractions();
      const isLandscape = this.props.mode === LANDSCAPE;
      // const { calendarTextColor } = this.context.muiTheme.datePicker;

      const styles = {
        calendarContainer: {
          transition: transitions.easeOut(),
        },
      };

      const {
        labelCancel,
        firstDayOfWeek,
        mode,
        labelOk,
        onPressCancel, // eslint-disable-line no-unused-vars
        onPressOk, // eslint-disable-line no-unused-vars
      } = this.props;

      return (
        <div className={`o-calendar o-calendar-date-picker ${mode}`}>
          <EventListener
            target="window"
            onKeyDown={this.handleWindowKeyDown}
          />
          <MDisplayDate
            disableYearSelection={this.props.disableYearSelection}
            onPressMonthDay={this.handleOnPressDateDisplayMonthDay}
            onPressYear={this.handleOnPressDateDisplayYear}
            monthDaySelected={this.state.displayMonthDay}
            mode={this.props.mode}
            selectedDate={this.state.selectedDate}
          />
          <div className="o-calendar-date-picker__calendar">
            {this.state.displayMonthDay &&
                        <div className="o-calendar-date-picker__calendar-container" style={styles.calendarContainer}>
                          <MToolbarCalendar
                            // DateTimeFormat={DateTimeFormat}
                            // locale={locale}
                            displayDate={this.state.displayDate}
                            prevMonth={toolbarInteractions.prevMonth}
                            nextMonth={toolbarInteractions.nextMonth}
                            onMonthChange={this.handleMonthChange}
                            onPressTitle={this.handleOnPressDateDisplayYear}
                          />
                          <div className="o-calendar-date-picker__week-title">
                            {daysArray.map((event, i) => (
                              <span key={i} className="o-calendar-date-picker__week-title-day">
                                {localizedWeekday(i, firstDayOfWeek)}
                              </span>
                            ))}
                          </div>
                          <SlideInTransitionGroup className="o-calendar-date-picker__transition-slide" direction={this.state.transitionDirection}>
                            <MMonthCalendar
                              ref={this.refCalendar}
                              displayDate={this.state.displayDate}
                              firstDayOfWeek={this.props.firstDayOfWeek}
                              key={this.state.displayDate.toDateString()}
                              minDate={this.props.minDate}
                              maxDate={this.props.maxDate}
                              onPressDay={this.handleOnPressDay}
                              selectedDate={this.state.selectedDate}
                              shouldDisableDate={this.props.shouldDisableDate}
                            />
                          </SlideInTransitionGroup>
                        </div>
            }
            {!this.state.displayMonthDay &&
                        <div className="o-calendar-date-picker__year-container">
                          {this.yearSelector()}
                        </div>
            }
            {labelOk &&
                        <MActionsCalendar
                          autoOk={this.props.autoOk}
                          labelCancel={labelCancel}
                          labelOk={labelOk}
                          disableOk={this._calendarComp && this._calendarComp.isSelectedDateDisabled()}
                          onPressCancel={onPressCancel}
                          onPressOk={onPressOk}
                        />
            }
          </div>
        </div>
      );
    }

    /**
     * @param {object} comp
     */
    refCalendar = (comp) => {
      // we do not remove the ref when the component gets unmouted as
      // the react-transistion SlideInTransitionGroup calls the callback ref
      // with null when a new element was created and the animaton of the
      // old one ends. This way it breaks the ref to the new element.
      // We simply remove the ref ourself on componentWillUnmount
      if (!comp) return;
      this._calendarComp = comp;
    }

    /**
     * click onto a single day handling
     *
     * @param {date} date
     * @param {object} event
     * @return {undefined}
     */
    handleOnPressDay = (date, event) => {
      this.setSelectedDate(date);
      if (this.props.onPressDay) this.props.onPressDay(event, date);
    };

    /**
     * click onto forward of backward for month (will be +1/-1)
     *
     * @param {number} months
     * @return {undefined}
     */
    handleMonthChange = (months) => {
      this.setState({
        transitionDirection: months >= 0 ? 'left' : 'right',
        displayDate: addMonths(this.state.displayDate, months),
      });
    };

    /**
     * year selection done
     *
     * @param {number} year
     * @param {object} event
     * @return {undefined}
     */
    handleOnPressYear = (year, event) => {
      const date = cloneDate(this.state.selectedDate);
      date.setFullYear(year);
      this.setSelectedDate(date, event);

      this.displayMonthDay();
    };

    /**
     * click onto day selection display element
     *
     * @return {undefined}
     */
    handleOnPressDateDisplayMonthDay = () => {
      this.displayMonthDay();
    };

    /**
     * click onto year selection display element
     *
     * @return {undefined}
     */
    handleOnPressDateDisplayYear = () => {
      this.displayYear();
    };

    /**
     * handling keyboard shortcuts if datepicker is active (open prop)
     *
     * @param {object} event
     * @return {undefined}
     */
    handleWindowKeyDown = (event) => {
      if (this.props.open) {
        switch (keycode(event)) {
          case 'up':
            if (event.altKey && event.shiftKey) {
              this.addSelectedYears(-1);
            } else if (event.shiftKey) {
              this.addSelectedMonths(-1);
            } else {
              this.addSelectedDays(-7);
            }
            break;

          case 'down':
            if (event.altKey && event.shiftKey) {
              this.addSelectedYears(1);
            } else if (event.shiftKey) {
              this.addSelectedMonths(1);
            } else {
              this.addSelectedDays(7);
            }
            break;

          case 'right':
            if (event.altKey && event.shiftKey) {
              this.addSelectedYears(1);
            } else if (event.shiftKey) {
              this.addSelectedMonths(1);
            } else {
              this.addSelectedDays(1);
            }
            break;

          case 'left':
            if (event.altKey && event.shiftKey) {
              this.addSelectedYears(-1);
            } else if (event.shiftKey) {
              this.addSelectedMonths(-1);
            } else {
              this.addSelectedDays(-1);
            }
            break;
        }
      }
    };

    /**
     * enable displayDayMonth
     *
     * @return {undefined}
     */
    displayMonthDay() {
      this.setState({
        displayMonthDay: true,
      });
    }

    /**
     * enable displayYear
     *
     * @return {undefined}
     */
    displayYear() {
      this.setState({
        displayMonthDay: false,
      });
    }

    /**
     * gets currently selected date
     *
     * @return {(date|undefined)}
     */
    getSelectedDate() {
      return this.state.selectedDate;
    }

    /**
     * calculate allowed toolbar interactions on months (back-/forward)
     *
     * @return {object}
     */
    getToolbarInteractions() {
      return {
        prevMonth: monthDiff(this.state.displayDate, this.props.minDate) > 0,
        nextMonth: monthDiff(this.state.displayDate, this.props.maxDate) < 0,
      };
    }

    /**
     * current date disabled?
     *
     * @return {object}
     */
    isSelectedDateDisabled() {
      if (!this.state.displayMonthDay) {
        return false;
      }

      return this._calendarComp.isSelectedDateDisabled();
    }

    /**
     * adds days to selection
     *
     * @param {number} days
     * @return {undefined}
     */
    addSelectedDays(days) {
      this.setSelectedDate(addDays(this.state.selectedDate, days));
    }

    /**
     * adds months to selection
     *
     * @param {number} months
     * @return {undefined}
     */
    addSelectedMonths(months) {
      this.setSelectedDate(addMonths(this.state.selectedDate, months));
    }

    /**
     * current date disabled?
     *
     * @param {number} years
     * @return {undefined}
     */
    addSelectedYears(years) {
      this.setSelectedDate(addYears(this.state.selectedDate, years));
    }

    /**
     * update date selection with render-affecting state calculations
     * (e.g. updates to any monthDay-views, animation directions, ...)
     *
     * @param {date} date
     * @param {date} newSelectedDate
     * @return {undefined}
     */
    setDisplayDate(date, newSelectedDate) {
      const newDisplayDate = getFirstDayOfMonth(date);
      const direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';

      if (newDisplayDate !== this.state.displayDate) {
        this.setState({
          displayDate: newDisplayDate,
          transitionDirection: direction,
          selectedDate: newSelectedDate || this.state.selectedDate,
        });
      }
    }

    /**
     * update date
     * this will call setDisplayDate() if necessary
     *
     * @param {date} date
     * @return {undefined}
     */
    setSelectedDate(date) {
      let adjustedDate = date;
      if (isBeforeDate(date, this.props.minDate)) {
        adjustedDate = this.props.minDate;
      } else if (isAfterDate(date, this.props.maxDate)) {
        adjustedDate = this.props.maxDate;
      }

      const newDisplayDate = getFirstDayOfMonth(adjustedDate);
      if (newDisplayDate !== this.state.displayDate) {
        this.setDisplayDate(newDisplayDate, adjustedDate);
      } else {
        this.setState({
          selectedDate: adjustedDate,
        });
      }
    }
    /**
     * creates a <MYearCalendar> react element
     *
     * @return {object}
     */
    yearSelector() {
      if (!this.props.disableYearSelection) {
        return (
          <MYearCalendar
            key={'years'}
            // displayDate={this.state.displayDate}
            onPressYear={this.handleOnPressYear}
            selectedDate={this.state.selectedDate}
            minDate={this.props.minDate}
            maxDate={this.props.maxDate}
          />
        );
      }
    }
}
OCalendarDatePicker.propTypes = {
  autoOk: PropTypes.bool,
  labelCancel: PropTypes.node,
  labelOk: PropTypes.node,
  disableYearSelection: PropTypes.bool,
  firstDayOfWeek: PropTypes.number.isRequired,
  initialDate: PropTypes.object,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  mode: PropTypes.oneOf([LANDSCAPE, PORTRAIT]),
  onPressCancel: PropTypes.func,
  onPressDay: PropTypes.func,
  onPressOk: PropTypes.func,
  open: PropTypes.bool,
  shouldDisableDate: PropTypes.func,
  startWithYears: PropTypes.bool,
};
OCalendarDatePicker.defaultProps = {
  firstDayOfWeek: 1,
  disableYearSelection: false,
  initialDate: new Date(),
  minDate: addYears(new Date(), -100),
  maxDate: addYears(new Date(), 100),
  mode: PORTRAIT,
  open: true,
  startWithYears: false,
};
export default OCalendarDatePicker;

